import request from "@/utils/request";

// 我的团队列表
export function getTeamList(params) {
  return request({
    url: "/user/customer/h5/myTeam",
    method: "get",
    params,
  });
}